import { __assign } from "tslib";
export var createHeaders = function (headerSettings) {
    return __assign({ 'Content-Type': 'text/plain' }, (typeof headerSettings === 'function'
        ? headerSettings()
        : headerSettings));
};
//# sourceMappingURL=shared-dispatcher.js.map